// extracted by mini-css-extract-plugin
export default {"underlined":"style_underlined__6l0GY","highlighted":"style_highlighted__cMgvo"};